import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { DecorativeLink } from '@massds/mayflower-react';

import './index.scss';

const Signatures = (props) => {
  const { signatures } = props;
  return(
    <div className="signatures">
      {signatures.map((signature, i) => {
        const key = `signature--${i}`;
        return(
          <div className="signature" key={key}>
            {(signature.signatureImg) && (
            <div className="signature--signature-image">
              {/* To avoid the same infomration (= name) for the person repeatedly, empty alt value for the signature image. */}
              <Img fixed={signature.signatureImg.src.childImageSharp.fixed} alt="" />
            </div>
            )}
            {(signature.link && signature.text) && (
            <div className="signature--name">
              <DecorativeLink {...signature.link} text={signature.text} />
            </div>
            )}
            {(!signature.link && signature.text) && (
            <div className="signature--name">
              <span>{signature.text}</span>
            </div>
            )}
            {(signature.title) && (<div className="signature--title">{signature.title}</div>)}
            {(signature.image) && (
            <div className="signature--image">
              {/* To avoid the same information (= name) for the person repeatedly, empty alt value for the signature image. */}
              <Img fixed={signature.image.src.childImageSharp.fixed} alt="" />
            </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

Signatures.propTypes = {
  /** an array of distinct signatures to be rendered by the component, one or more * */
  signatures: PropTypes.arrayOf(PropTypes.shape({
    /** Based off of a relative file path to the image of the signature,
        this expects a gatsby graphql image object.* */
    signatureImg: PropTypes.image,
    /** the link text rendered, should be the name of the individual whose signature is rendered (e.g. Charlie Baker) * */
    text: PropTypes.string,
    /** the title of the individual whose signature is rendered (e.g. Governor) * */
    title: PropTypes.string,
    /** a complete path to the individual bio page * */
    link: PropTypes.shape(DecorativeLink.props),
    /** Based off of the relative file path to the image rendered beneath the signature in the source json,
        this expects a gatsby graphql image object.* */
    image: PropTypes.image
  }))
};

export default Signatures;
